import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

import { DEV_HOSTS } from '../enum';

// Initializes Google Tag manager
export const useGtmTracker = (trackingId: string | undefined) => {
    // Only initialize google analytics on deployed environments
    useEffect(() => {
        if (!trackingId) return;
        if (Object.values(DEV_HOSTS).some((host) => window.location.href.includes(host))) return;
        TagManager.initialize({
            gtmId: trackingId,
        });
    }, [trackingId]);
};
